import { createApiRef } from '@backstage/core-plugin-api';

export interface MdgpDbApiProxy {
  get<T>(path: string): Promise<T | Response>;
}

export const MdgpDbApiProxyRef = createApiRef<MdgpDbApiProxy>({
  id: 'plugin.mdgp-db-api.service',
});

export type ApiResponse<T> = {
  data: T;
};

export type DomainSystem = {
  system_id: string;
  system_name: string;
  system_retrieve_indicator: boolean;
  system_delete_indicator: boolean;
  system_contact: string;
};

export type IncompleteRequest = {
  request_id: string;
  request_type: string;
  request_received_timestamp: Date;
  system_name: string;
  system_contact: string;
};
